import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ConsolidadoLaboratorioEntity, ServicioLaboratorioService, Sedes, ConsolidadoLaboratorioBodyEntity,
  ConsolidadoLaboratorioExcelEntity } from 'src/app/services/servicio-laboratorio.service';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { FileService } from 'src/app/services/utils/file.service';
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/utils/excel.service';

@Component({
  selector: 'app-header-consolidado-laboratorio',
  templateUrl: './header-consolidado-laboratorio.component.html',
  styleUrls: ['./header-consolidado-laboratorio.component.css']
})
export class HeaderConsolidadoLaboratorioComponent implements OnInit, OnChanges {

  canDownload: boolean; // Indicador que existe data
  loading: boolean; // Indicador de carga en header
  downloading: boolean; // Indicado de descarga en header
  sede: number; // Valor sede del formulario
  fechaInicial: string; // Valor fecha inicial del formulario
  fechaFinal: string; // Valor fecha final del formulario
  mensajeError: string; // Mensaje de error

  sedes: Sedes[]; // Lista de sedes para filtro

  @Input() public objectConsolidadoEntity: ConsolidadoLaboratorioEntity;
  @Input() public objectDataConsolidadoEntity: ConsolidadoLaboratorioBodyEntity[];
  @Output() filtrosSeleccionados: EventEmitter<ConsolidadoLaboratorioEntity>;

  constructor(private servicioLaboratorio: ServicioLaboratorioService,
    private servicioFecha: FechaService,
    private servicioArchivo: FileService,
    private servicioExcel: ExcelService,
    private http: HttpClient) {
    this.loading = true;
    this.filtrosSeleccionados = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }

  ngOnChanges() {

  }

  init() {
    if (this.objectConsolidadoEntity && this.objectConsolidadoEntity.fechaInicial > 0) {
      this.fechaInicial = this.servicioFecha.getInputValue(this.objectConsolidadoEntity.fechaInicial);
    }

    if (this.objectConsolidadoEntity && this.objectConsolidadoEntity.fechaFinal > 0) {
      this.fechaFinal = this.servicioFecha.getInputValue(this.objectConsolidadoEntity.fechaFinal);
    }

    if (this.objectConsolidadoEntity && this.objectConsolidadoEntity.sede) {
      this.sede = this.objectConsolidadoEntity.sede;
    }

    if (!this.sedes || this.sedes.length === 0) {
      this.getSedes();
      if (this.objectConsolidadoEntity && this.objectConsolidadoEntity.sede) {
        this.sede = Number(this.objectConsolidadoEntity.sede);
      } else {
        this.sede = -1;
      }
    }

    if (this.fechaInicial && this.fechaFinal && this.sede !== 0) {
      this.onGenerar();
    }

  }

  async getSedes() {
    try {
      const response = await this.servicioLaboratorio.getSedes(this.objectConsolidadoEntity);
      if (response != null) {
        response.subscribe((data: Sedes[]) => {
          this.sedes = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          if (err.status === 500) {
            this.sedes = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.log(e);

    }
  }

  onGenerar() {
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    const obj: ConsolidadoLaboratorioEntity = {
      codigo: this.objectConsolidadoEntity.codigo,
      fechaInicial: 0,
      fechaFinal: 0,
      sede: -1
    };

    if (inicio === null || inicio.getTime() === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Inicial</strong>.');
    } else if (fin === null || fin.getTime() === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Final</strong>.');
    } else if (Number(this.sede) === -1) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Sede</strong>.');
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
    } else {
      obj.fechaInicial = inicio.getTime();
      obj.fechaFinal = fin.getTime();
      obj.sede = Number(this.sede);

      this.objectConsolidadoEntity = obj;
      this.canDownload = obj.fechaInicial > 0;
      this.filtrosSeleccionados.emit(obj);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('consolidado-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarPDF() {
    this.downloading = true;
    try {
      if (this.validatePDF()) {
        const data = xepOnline.Formatter.Html('consolidado-print', { resolution: '200' });
        const html = `<html><head><meta charset="UTF-8"/></head><body>${data}</body></html>`;
        const response = this.servicioArchivo.generatePDF(html, 'Consolidado Laboratorio', 'consolidadoLaboratorio');
        if (response != null) {
          response.subscribe((data1: any) => {
            const filename = data1.filename;
            this.servicioArchivo.downloadFile(filename)
              .subscribe((data2: any) => {
                saveAs(data2, filename);
                this.downloading = false;
              }, err => {
                this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
                console.error('Error download', err);
                this.downloading = false;
              });
          }, (err: HttpErrorResponse) => {
            console.error('Error', err);
            this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
            this.downloading = false;
          });
        } else {
          console.error('Response Null');
        }
        this.downloading = false;
      } else {
        this.downloading = false;
      }
    } catch (e) {
      this.mostrarMensaje('Error al intentar generar archivo pdf, reporte caso al administrador');
      this.downloading = false;
      console.error(e);
    }
  }

  onDescargarExcel() {
    this.downloading = true;
    const initialData: ConsolidadoLaboratorioBodyEntity[] = this.objectDataConsolidadoEntity;
    const finalData: ConsolidadoLaboratorioExcelEntity[] = [];

    if (initialData && initialData.length > 0) {
      initialData.forEach((d: ConsolidadoLaboratorioBodyEntity) => {
        const f: ConsolidadoLaboratorioExcelEntity = {
          sede: d.sede,
          orden: d.numeroOrden,
          identificacion: d.identificacionPaciente,
          afiliado: `${d.apellidosPaciente} ${d.nombresPaciente}`,
          codigo: d.codigoServicio,
          laboratorio: d.servicio,
          estado: (d.estadoSolicitud === 1 ? 'PENDIENTE' : (d.estadoSolicitud === 2 ? 'ATENDIDO' : '')),
          fechaEntrega: new Date(d.fechaEntrega),
          fechaSolicitud: new Date(d.fechaSolicitud),
          usuarioCreacion: d.usuarioCreacion
        };
        finalData.push(f);
      });
      this.servicioExcel.exportAsExcelFile(finalData, 'consolidadoLaboratorio', 'Consolidado Laboratorios');
      this.downloading = false;
    } else {
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }
  }


  // Auxiliares

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 5000);
  }

  validatePDF(): boolean {
    if (!this.objectDataConsolidadoEntity || this.objectDataConsolidadoEntity.length < 500) {
      return true;
    } else {
      this.mostrarMensaje('El reporte supera los 500 registros, por favor genere un archivo excel.');
      return false;
    }
  }

}
